import React, { useCallback, useState, useContext, useEffect } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import { useAuthentication } from 'gw-digital-auth-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './EnrollmentComponent.metadata.json5';
import styles from './EnrollmentComponent.module.scss';
import messages from './EnrollmentComponent.messages';
import {Link} from "gw-components-platform-react";
import { ModalNextProvider, Loader} from '@jutro/components';
import EnrollmentTable from '../EnollmentTable/EnollmentTable';

const ENROLLMENT_ERRORS = {
    enrollmentInvalid: 'enrollmentInvalid',
    enrollmentFailed: 'enrollmentFailed',
    fieldEmpty: 'fieldEmpty'
};

function EnrollmentComponent(props) {
    const translator = useContext(TranslatorContext);
    const [formData, updateFormData] = useState({});
    const [enrollmentStatus, setEnrollmentStatus] = useState();
    const [availablePolicies, setAvailablePolicies] = useState([]);
    const {authHeader, refreshToken} = useAuthentication();
    const { EnrollmentService } = useDependencies('EnrollmentService');
    const [enrollmentPolicy, setEnrollmentPolicy] = useState();
    const [userPolicies, setUserPolicies] = useState([]);
    const auth = useAuthentication();
    let pageRef = React.useRef();
    const [isLoading, setLoadingState] = useState(false);
    const [isEnrolled, setisEnrolled] = useState(true);

    const {
        enrollmentType,
        onSuccessEnrollment,
        informationText,
        informationAdditionalText,
        onReturnLinkClick,
        returnLinkText,
        enrollButtonText
    } = props;

    useEffect(() => {          
        window.scroll(0,0)
        setLoadingState(true);
        
        EnrollmentService.getAvailablePoliciesForEnrollment_EY(
            auth.name,
            authHeader
            ).then((response) => {
                setUserPolicies(response)
                setLoadingState(false);
            }).catch((error) => {setLoadingState(false);});
    }, [setUserPolicies]);

    const enrollPolicy = useCallback(
        (evt) => {
            if (evt) {
                evt.preventDefault();
            }
            const { policyNumber} = formData;

            addPolicy(policyNumber, userPolicies)
        },
        [EnrollmentService, authHeader, enrollmentType, formData, onSuccessEnrollment, refreshToken, pageRef, userPolicies]
    );
    
    const addPolicy = useCallback(
        (policyNumber, policyList) => {

            if (_.isEmpty(policyNumber)) {
                setEnrollmentStatus(ENROLLMENT_ERRORS.fieldEmpty);
                return Promise.resolve();
            }

            setisEnrolled(false)
            return EnrollmentService.addEnrollmentRecord(
                {
                    details: {
                        policyNumber: policyNumber,
                        effectiveUser: auth.name,
                        userName: auth.user_name
                    },
                    type: enrollmentType
                },
                authHeader
            )
                .then((resp) => {
                    refreshToken().then(() => {
                            updateFormData({});
                            setEnrollmentPolicy(policyNumber)                                                  
                            setAvailablePolicies(resp);
                            setEnrollmentStatus('enrollmentRequestSucceeded');
                            const i = policyList.indexOf(policyNumber)  
                            if(i !== -1) {                          
                                let newData = _.clone(policyList) ;
                                newData.splice(i, 1);
                                setUserPolicies(newData)
                            }
                            setisEnrolled(true)

                    });
                })
                .catch((error) => {
                    updateFormData({});
                    setAvailablePolicies([]);
                    setisEnrolled(true)
                    if ((error && error.baseError && ( error.baseError.error && (error.baseError.error.message.includes('616'))) ||  error.baseError.includes('616'))) {
                        setEnrollmentStatus(ENROLLMENT_ERRORS.enrollmentInvalid);                        
                    } else if((error && error.baseError && ( error.baseError.error && (error.baseError.error.message.includes('602'))) ||  error.baseError.includes('602'))){
                        setEnrollmentStatus('enrollmentRequestInvalid');
                        triggerConfirmation();
                    } else {
                        setEnrollmentStatus(ENROLLMENT_ERRORS.enrollmentFailed);
                    }
                    const element = ReactDOM.findDOMNode(pageRef.current).parentNode;
                    element.children[0].children[1].children[0].focus();
                    
                });
        },
        [EnrollmentService, authHeader, enrollmentType, formData, onSuccessEnrollment, refreshToken, pageRef, userPolicies, setUserPolicies, setisEnrolled, updateFormData]
    );

    const triggerConfirmation =async() => {
        try {
            const results = await ModalNextProvider.showConfirm({
                status: 'info', 
                icon: 'mi-error-outline', 
                title: translator(messages.errorAddingPolicy), 
                message: requestForEnrollmentText(),
                confirmButtonText: translator(messages.ok),
                cancelButtonText: translator(messages.edit), 
            });
            if(results == "confirm"){
                requestEnrollment();
            }
        } catch (ex) {
               // 'close' rejection case
        }
    }

    const writeValue = useCallback(
        (value, path) => updateFormData({
            ...formData,
            [path]: value
        }),
        [formData]
    );

    const getSuccessNotificationMessage = () => {

        return (
            <div>
                <span>
                    {translator(messages.accessToYourPolicy, {policyNumber: enrollmentPolicy})}
                </span>
            </div>
        );
    }

    const getpendingNotification = () => {        
        return (
            <div>
                <span>
                    {translator(messages.enrollmentPendingNotificationMessage, {policyNumber: enrollmentPolicy})}
                </span>
            </div>
        );
    }

    const requestForEnrollmentText = () => {
        return (
            <div>
                <div>{translator(messages.confirmPolicyDetailsMessage)}</div>
                <div>{translator(messages.sendEnrollmentRequest1)}</div>
            </div>            
        )
        
    }

    const requestEnrollment = useCallback(
        (evt) => {
            if (evt) {
                evt.preventDefault();
            }

            const { policyNumber} = formData;

            if (_.isEmpty(policyNumber)) {
                setEnrollmentStatus(ENROLLMENT_ERRORS.fieldEmpty);
                return Promise.resolve();
            }

            /* return EnrollmentService.requestPolicyEnrollment(
                {
                    details: {
                        policyNumber: policyNumber,
                        effectiveUser: auth.name,
                        userName: auth.user_name                       
                    },
                    type: enrollmentType
                },
                authHeader
            ).then((resp) => {
                    refreshToken().then(() => {
                        setEnrollmentPolicy(policyNumber)
                        updateFormData({});
                        setEnrollmentStatus('enrollmentRequestPending');                    
                    });
                })
                .catch((error) => {
                }); */

            return EnrollmentService.requestPolicyEnrollmentEmail(
                {
                    details: {
                        policyNumber: policyNumber,
                        effectiveUser: auth.name,
                        userName: auth.user_name
                    },
                    type: enrollmentType
                },
                authHeader
            ).then((resp) => {
                refreshToken().then(() => {
                    console.log('success');
                });
            })
                .catch((error) => {
                });
        },
        [EnrollmentService, authHeader, enrollmentType, formData, onSuccessEnrollment, refreshToken]
    );

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const overrideProps = {

        enrollmentErrorMessageContainer: {
            visible: 
                (!_.isUndefined(enrollmentStatus)
                && !((enrollmentStatus == 'enrollmentRequestSucceeded') || (enrollmentStatus == 'enrollmentRequestInvalid') || (enrollmentStatus == 'enrollmentRequestPending')))
        },
        policyNumber: {
            ref: pageRef
        },
        enrollmentErrorMessage: {
            message: translator(messages[enrollmentStatus])
        },
        enrollmentSuccessNotificationContainer: {
            visible: enrollmentStatus === 'enrollmentRequestSucceeded'
        },
        enrollmentSuccessNotification: {
            message: availablePolicies.length !== 0 ? getSuccessNotificationMessage() : ''
        },
        enrollmentPendingNotificationContainer: {
            visible: enrollmentStatus === 'enrollmentRequestPending'
        },
        enrollmentPendingNotification: {
            message: getpendingNotification()
        },
        returnLink: {
            to: _.isUndefined(onReturnLinkClick) ? '/home' : '#',
            content: translator(returnLinkText),
            onClick: onReturnLinkClick
        },
        enrollButton: {
            content: translator(enrollButtonText),
            trigger: enrollPolicy
        },
        enrollmentTableComponentId:{
            data: userPolicies,
            enrollPolicy: addPolicy,
            visible: !_.isEmpty(userPolicies),
            isEnrolling: !isEnrolled
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            EnrollmentTable: EnrollmentTable
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={formData}
            overrideProps={overrideProps}
            onValueChange={writeValue}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

EnrollmentComponent.propTypes = {
    enrollmentType: PropTypes.string.isRequired,
    onSuccessEnrollment: PropTypes.func,
    onReturnLinkClick: PropTypes.func,
    returnLinkText: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string
    }),
    enrollButtonText: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string
    }),
    informationText: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string
    }).isRequired,
    informationAdditionalText: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string
    }).isRequired
};

EnrollmentComponent.defaultProps = {
    onSuccessEnrollment: undefined,
    onReturnLinkClick: undefined,
    returnLinkText: messages.returnToHomePage,
    enrollButtonText: messages.enroll
};

export default EnrollmentComponent;
